import { yupResolver } from "@hookform/resolvers/yup";
import  { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Column,
  Row,
  Wrapper,
  WrapperCard,
  WrapperContent,
  WrapperSubHeader,
} from "../../../components/common";
import ContactFormAccordian from "../../../components/common/Accordian/ContactFormAccordian";
import BreadCrumbComponent from "../../../components/common/BreadCrumbComponent/BreadCrumbComponent";
import GeneralDetailsFormComponent from "../../../components/common/FormComponent/Contact/GeneralDetailsFormComponent";
import { axiosFunction } from "../../../components/commonFunctions";
import useResponsive from "../../../hooks/useResponsive";
import Footer from "../../../layout/footer/Footer";
import { v2ReactURL } from "../../../utils/constant";
import { DateFormat } from "../../../utils/DateFormat";
import { EditContactContainer } from "./EditContactContainer";
import AddressDetailsFormNew from "../../../components/common/FormComponent/Contact/AddressDetailFormNew";
import ErrorPage from "../../Error/ErrorPage";
import { toastMessage } from "../../../components/commonFunctions";
import Loader from "../../../utils/Loader";
import useContactValidation from "../../../hooks/useContactValidation";
import { CityList, ContactEditSchema, ContactEditType, CountryLists, StateList } from './EditContactSchema';
import {AddressDetails, EditAndAddContactType, formAdditiondetailsObj} from "./EditAndAddContactSchema";
import { gstType, GstValidMsg, showVerifyBtn } from '../../../components/common/FormComponent/Contact/FormComponentSchema';
import useLocationApi from "../../../hooks/useLocationApi";
import {resetPhoneNo} from "../../../store/Contact/phoneNoSlice.ts";
import { useToggleContext } from "../../../layout/ToggleContext.tsx";
export interface ErrorState {
  code: string;
  message: string;
}
const EditContact = () => {
  const contactType = useSelector((state : any) => state.contactType);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const [editedData, setEditedData] = useState<Partial<ContactEditType>>({});
  const params = useParams();
  const { isToggle } = useToggleContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const phoneNo = useSelector((state : any) => state.phoneNo);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [deletedAddress, setDeletedAddress] = useState<string[]>([]);

  const [selectedGSTType, setSelectedGSTType] = useState<gstType>({
    value: "UnRegistered",
    label: "UnRegistered",
  });
  const [error, setError] = useState<ErrorState | null>(null);

 
  
  const [isLoading, setLoading] = useState<boolean>(true);

  const [showVerifyBtn, setShowVerifyBtn] = useState<showVerifyBtn>({});
  const [gstValidMsg, setGstValidMsg] = useState<GstValidMsg>({});


  const accountGroup = editedData?.AccountGroupData?.find(
    (acc) => acc.isDefault === 1
  );

  // const accountGrpDefaultValue = {
  //   label: `${accountGroup?.accountGroupName || ""} (${
  //     accountGroup?.parentGroup || ""
  //   })`,
  //   value: editedData?.AccountGroupData?.find((acc) => acc.isDefault === 1)
  //     ?.accountGroupId,
  // };

  const accGroupId = editedData?.ContactDetails?.accountGroupId
    // editedData?.ContactDetails?.accountGroupId === 0
    //   ? editedData?.ContactDetails?.accountCustomVo?.group?.accountGroupId
    //   : editedData?.ContactDetails?.accountGroupId;

  const selectedAccountGroup = editedData?.AccountGroupData?.find(
    (acc) => acc.accountGroupId === accGroupId
  );

  const {
    CustomerValidationSchema,
    SupplierValidationSchema,
    TransportValidationSchema,
  } = useContactValidation(Number(params.contactId)); 
  const typeWiseValidationSchema =
    contactType === "customers"
      ? CustomerValidationSchema
      : contactType === "suppliers"
      ? SupplierValidationSchema
      : TransportValidationSchema;


    const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    control,
    watch,
    getValues,
  }   = useForm<formAdditiondetailsObj>({
    defaultValues: {
      mobNo: null,
      panNo: null,
      tanNo: null,
      bankIfsc: null,
      firstName: "",  
      companyName: null,
      bankAcNo: null,
      customerTaxType: "gst",
      bankBranch: null,
      code: null ,
      telephone: null,
      email: null,
      whatsappNo: null,
      transporterId: null,
      remark: null,
      lastName : null,
    },
    resolver: yupResolver(typeWiseValidationSchema as any),
    mode: "onChange",
  });
  const customerTaxType = watch("customerTaxType");
 

  const { fields, append, remove } = useFieldArray({
    control,
    name: "addressDetails",
  });
  const { getCountryList, getCityList, getStateList } = useLocationApi();
 
  useEffect(() => {
    const editContactDetail = async () => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/${params.contactId}/edit`,
        "GET"
      );

      if (res?.status == 200) {
        if (res?.data["access-denied"] == "accessdenied/accessdenied") {
          setError({
            code: "200",
            message:
              "Sorry, this area's VIP only. Your pass must've gotton lost in the mail.",
          });
        }
        if (res?.data["error-message"] === "error/error-404") {
          setError({
            code: "404",
            message:
              res?.message ||
              "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
          });
        }
        if (res?.data) {
          const parsedResult = ContactEditSchema.safeParse(res.data);
        
          if (!parsedResult.success) {

            console.error("Parsing error:", parsedResult.error.format());
          } else {
          
               
        setEditedData(res?.data);
        setLoading(false);
          }
        } else {
          console.error("Response data is null or undefined.");
        }
     
      } else if (
        res?.code == "ERR_NETWORK" ||
        res?.message == "network error"
      ) {
        setError({
          code: res?.code || "502",
          message:
          res?.message ||
            "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon!&nbsp;",
        });
        setLoading(false);
      } else if (res?.response?.status == 400) {
        setError({
          code: res?.response?.status || "400",
          message:
            res?.message ||
            "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
        });
        setLoading(false);
      } else if (res?.response?.status == 404) {
        setError({
          code: res?.response?.status || "404",
          message:
            res?.message ||
            "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
        });
      } else if (res?.response?.status == 500) {
        setError({
          code: res?.response?.status || "500",
          message:
            res?.message ||
            "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
        });
        setLoading(false);
      }
    };

    editContactDetail();
  }, []);

    useEffect(() => {
      return () => {
        dispatch(resetPhoneNo());
      };
    }, []);
 
  useEffect(() => {
    setValue("firstName", editedData?.ContactDetails?.firstName ?? "");
    setValue("customerTaxType",editedData?.type === 'customers' ? editedData?.ContactDetails?.vatNo?.trim() ? "vat" : "gst" : sessionList?.governmentTaxType || "gst");
    setValue("lastName", editedData?.ContactDetails?.lastName || null);
    setValue("companyName", editedData?.ContactDetails?.companyName || null);
    setValue("code", editedData?.ContactDetails?.code || "");
    setValue("panNo", editedData?.ContactDetails?.panNo || null);
    setValue("mobNo", editedData?.ContactDetails?.mobNo || null);
    setValue("telephone", editedData?.ContactDetails?.telephone || null);
    setValue("whatsappNo", editedData?.ContactDetails?.whatsappNo || null);
    setValue("email", editedData?.ContactDetails?.email || "");
    setValue("dateOfBirth1", editedData?.ContactDetails?.dateOfBirth ? String(editedData.ContactDetails.dateOfBirth) : null);
    setValue("anniversaryDate1", editedData?.ContactDetails?.anniversaryDate ? String(editedData.ContactDetails.anniversaryDate) : null);
    // setValue("debitAmount", editedData?.ContactDetails?.debitAmount || null);
    // setValue("creditAmount", editedData?.ContactDetails?.creditAmount || null);
    //  console.log("editedData?.ContactDetails?.creditAmount", editedData?.ContactDetails?.paymentTermName)
    setValue("paymentTermId",  {
      label: editedData?.ContactDetails?.paymentTermName ?? "Select Payment Term",
      value: editedData?.ContactDetails?.paymentTermId ?? null,
    }
    );
    setValue("remark", editedData?.ContactDetails?.remark || null);
    if (
      editedData?.ContactDetails?.customerCategoryId &&
      editedData?.ContactDetails?.customerCategoryName
    ) {
      setValue("customerCategoryId", {
        value: editedData.ContactDetails.customerCategoryId,
        label: editedData.ContactDetails.customerCategoryName,
      });
    }
    
    const membershipId =  editedData?.ContactDetails?.membershipId != null ? String(editedData.ContactDetails.membershipId) : null
    const membershipDetails = editedData?.membershiplist?.find(item => item.membershipId === Number(membershipId));
    setValue("membershipId", {
      membershipId: membershipId,
      label: membershipId
        ? membershipDetails?.membershipName ?? "Select Membership"
        : "Select Membership",
    });

    setValue("accountGroupId", {
      value: selectedAccountGroup?.accountGroupId  ?? 0,
      label:
        `${selectedAccountGroup?.accountGroupName || ""} (${
          selectedAccountGroup?.parentGroup || ""
        })`,
    });

    // Suppliers
    setValue("tanNo", editedData?.ContactDetails?.tanNo || null);
    setValue("vatNo", editedData?.ContactDetails?.vatNo || null);
    setValue("bankName", editedData?.ContactDetails?.bankName || null);
    setValue("bankBranch", editedData?.ContactDetails?.bankBranch || null);
    setValue("bankAcNo", editedData?.ContactDetails?.bankAcNo || null);
    setValue("bankIfsc", editedData?.ContactDetails?.bankIfsc || null);
    setValue("supplierType", editedData?.ContactDetails?.contactType || "");

    // Transporters
    setValue("transporterId", editedData?.ContactDetails?.transporterId || "");
    setValue("customerType", editedData?.ContactDetails?.contactType || null);
  }, [editedData]);

  const updatedAddIds = editedData?.ContactDetails?.contactAddress
  ?.map((add) => ({
    id: add.contactAddressId ? Number(add.contactAddressId) : 0, // Set new addresses to 0
    isNew: !add.contactAddressId, // Identify new addresses
  }))
  ?.filter(
    (add) => !deletedAddress.some((deletedId) => Number(deletedId) === add.id)
  );

// console.log("deletedAddress", deletedAddress);
// console.log("updatedAddIds", updatedAddIds);

const updatedAddressValue = updatedAddIds?.map((add) =>
  add.isNew ? 0 : add.id
);

// console.log("updatedAddressValue", updatedAddressValue);


  const whatsappPrefix = phoneNo?.prefixes?.whatsappNo
    ? `+${phoneNo.prefixes.whatsappNo}`
    : "";
  const mobNoPrefix = phoneNo?.prefixes?.mobNo
    ? `+${phoneNo.prefixes.mobNo}`
    : "";

  const contactAddressVos = (data : EditAndAddContactType) => {
  
    return data?.addressDetails?.map((addressData : AddressDetails, index : number) => {
      return {
        gstType: !data.vatNo ? addressData?.gstType?.value || "UnRegistered" : "UnRegistered",
        firstName: addressData?.contactFirstName || "",
        lastName: addressData?.contactLastName,
        companyName: addressData?.contactCompanyName,
        countryDialCodePrefix: phoneNo?.prefixes[
          `addressDetailsmobNo[${index}]`
        ]
          ? `+${phoneNo?.prefixes[`addressDetailsmobNo[${index}]`]}`
          : "+91",
        phoneNo: addressData?.mobNo,
        email: addressData?.contactEmail,
        addressLine1: addressData?.addressLine1,
        addressLine2: addressData?.addressLine2,
        countriesCode: addressData?.countriesCode?.value,
        stateCode: addressData?.state?.value,
        cityCode: addressData?.city?.value,
        pinCode: addressData?.pincode || addressData?.pinCode,
        contactAddressId: updatedAddressValue && updatedAddressValue[index],
        isDefault: addressData.isDefault,
        countriesName: addressData?.countriesCode?.label,
        stateName: addressData?.state?.label,
        cityName: addressData?.city?.label,
        GSTIN: !data.vatNo ? addressData?.GSTIN : "",
      };
    });
  };

  const typeWiseContact = (data : EditAndAddContactType) => {
    return contactType === "customers"
      ? data.customerType
      : contactType === "suppliers"
      ? data.supplierType
      : "";
  };

  const payloadData = (data : formAdditiondetailsObj, createnew : number, createinvoice : number, preview : number) => {
    
    return {
      type: contactType,
      contactType: typeWiseContact(data),
      imgLocation: "",
      deleteAddress: deletedAddress,
      createnew: createnew,
      createinvoice: createinvoice,
      preview: preview,
      contactId: editedData?.ContactDetails?.contactId,
      isBranch: 0,
      accountCustomVo: {
        accountCustomId:
          editedData?.ContactDetails?.accountCustomId,
      },
      shopifySourceId: 0,
      deletecontactProductIds: "",
      hiddenSessionCountryCode: "IN",
      oldMemberShipid:
        editedData?.ContactDetails?.memberShipMasterVo?.membershipId,
      accountGroupId: data.accountGroupId.value,
      firstName: data.firstName,
      lastName: data.lastName,
      companyName: data.companyName,
      supplierCode: contactType !== "transport" ? data.code : "" ,
      email: data.email,
      countryDialCodePrefix: mobNoPrefix,
      mobNo: data.mobNo,
      panNo: data.panNo,
      telephone: data.telephone,
      remark: data.remark,
      creditLimit: data.creditAmount,
      creditAmount: data.creditAmount,
      ...(data.paymentTermId.value && {
        paymentTermVo: {
          paymentTermId: data.paymentTermId.value || 0,
        },
      }),
      tanNo: contactType === "suppliers" ? data.tanNo : "",
      vatNo:  data.vatNo || "",
      countryDialCodePrefixWhatsapp: whatsappPrefix,
      whatsappNo: data.whatsappNo,
      dateOfBirth1: DateFormat(data.dateOfBirth1),
      anniversaryDate1: DateFormat(data.anniversaryDate1),
      customerCategoryName: data.customerCategoryId?.label || "",
      customerCategoryId: data.customerCategoryId?.value || "",
      ...(data.membershipId.membershipId && {
        memberShipMasterVo: {
          membershipId: data.membershipId.membershipId || 0,
        },
      }),
      transporterId: contactType === "transport" ? data.transporterId : 0,
      commission: 0.0,
      contact_type: data.customerType,
      bankIfsc: data.bankIfsc || "",
      bankName: data.bankName || "",
      bankBranch: data.bankBranch || "",
      bankAcNo: data.bankAcNo || "",
      contactAddressVos: contactAddressVos(data),
    };
  };

  const onSave = async (data : formAdditiondetailsObj) => {
    setIsLoadingBtn(true);
    const response = await axiosFunction(
      `${v2ReactURL}/contact/insert`,
      "POST",
      payloadData(data, 0, 0, 0)
    );
    // console.log("dataaaa", data)
    if (response?.data?.status) {
      navigate(
        `/reactcontact/${contactType}/${response.data.response.ContactId}`
      );
    } else if (
      response?.code == "ERR_NETWORK" ||
      response?.message == "network error"
    ) {
      setError({
        code: response?.code || "502",
        message:
          response?.message ||
          "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon!&nbsp;",
      });
    } else if (response?.response?.status == 400) {
      setError({
        code: response?.response?.status || "400",
        message:
          response?.message ||
          "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
      });
    } else if (response?.response?.status == 404) {
      setError({
        code: response?.response?.status || "404",
        message:
          response?.message ||
          "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
      });
    } else if (response?.response?.status == 500) {
      setError({
        code: response?.response?.status || "500",
        message:
          response?.message ||
          "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
      });
    } else if (response?.data?.response == "accessdenied/accessdenied") {
      toastMessage("Access Denied");
    }
    else {
      setIsLoadingBtn(false); 
    }
  };

  const onCreateNewSave = async (data : formAdditiondetailsObj) => {
    const response = await axiosFunction(
      `${v2ReactURL}/contact/insert`,
      "POST",
      payloadData(data, 1, 0, 0)
    );
    if (response?.data?.status) {
      navigate(`/reactcontact/new`);
    } else if (
      response?.code == "ERR_NETWORK" ||
      response?.message == "network error"
    ) {
      setError({
        code: response?.code || "502",
        message:
          response?.message ||
          "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon!&nbsp;",
      });
    } else if (response?.response?.status == 400) {
      setError({
        code: response?.response?.status || "400",
        message:
          response?.message ||
          "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
      });
    } else if (response?.response?.status == 404) {
      setError({
        code: response?.response?.status || "404",
        message:
          response?.message ||
          "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
      });
    } else if (response?.response?.status == 500) {
      setError({
        code: response?.response?.status || "500",
        message:
          response?.message ||
          "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
      });
    } else if (response?.data?.response == "accessdenied/accessdenied") {
      toastMessage("Access Denied");
    }
  };

  const onCreateInvoiceSave = async (data : formAdditiondetailsObj) => {
    setIsLoadingBtn(true);
    const response = await axiosFunction(
      `${v2ReactURL}/contact/insert`,
      "POST",
      payloadData(data, 0, 1, 0)
    );
    if (response?.data?.status) {
      const redirectLink = response.data.response.LINK;
      window.location.href = redirectLink;
    } else if (
      response?.code == "ERR_NETWORK" ||
      response?.message == "network error"
    ) {
      setError({
        code: response?.code || "502",
        message:
          response?.message ||
          "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon!&nbsp;",
      });
    } else if (response?.response?.status == 400) {
      setError({
        code: response?.response?.status || "400",
        message:
          response?.message ||
          "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
      });
    } else if (response?.response?.status == 404) {
      setError({
        code: response?.response?.status || "404",
        message:
          response?.message ||
          "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
      });
    } else if (response?.response?.status == 500) {
      setError({
        code: response?.response?.status || "500",
        message:
          response?.message ||
          "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
      });
    } else if (response?.data?.response == "accessdenied/accessdenied") {
      toastMessage("Access Denied");
    }
    else {
      setIsLoadingBtn(false);
    }
  };

  const onPreviewSave = async (data : formAdditiondetailsObj) => {
    setIsLoadingBtn(true);
    const response = await axiosFunction(
      `${v2ReactURL}/contact/insert`,
      "POST",
      payloadData(data, 0, 0, 1)
    );
    if (response?.data?.status) {
      navigate(
        `/reactcontact/${contactType}/${response.data.response.ContactId}`
      );
    } else if (
      response?.code == "ERR_NETWORK" ||
      response?.message == "network error"
    ) {
      setError({
        code: response?.code || "502",
        message:
          response?.message ||
          "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon!&nbsp;",
      });
    } else if (response?.response?.status == 400) {
      setError({
        code: response?.response?.status || "400",
        message:
          response?.message ||
          "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
      });
    } else if (response?.response?.status == 404) {
      setError({
        code: response?.response?.status || "404",
        message:
          response?.message ||
          "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
      });
    } else if (response?.response?.status == 500) {
      setError({
        code: response?.response?.status || "500",
        message:
          response?.message ||
          "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
      });
    } else if (response?.data?.response == "accessdenied/accessdenied") {
      toastMessage("Access Denied");
    }
    else {
      setIsLoadingBtn(false);
    }
  };

  const customerName = `${
    editedData?.ContactDetails?.firstName
      ? editedData?.ContactDetails?.firstName
      : ""
  } ${
    editedData?.ContactDetails?.lastName
      ? editedData?.ContactDetails?.lastName
      : ""
  } ${
    editedData?.ContactDetails?.companyName
      ? editedData?.ContactDetails?.companyName
      : ""
  }`;
  const isMobile = useResponsive();

  useEffect(() => {
    const fetchContactDetails = async () => {
      const newContactCreatedDetail = editedData;
      if (newContactCreatedDetail) {
        const contactDetails = newContactCreatedDetail?.ContactDetails?.contactAddress;
        
        if (contactDetails) {
          await Promise.all(
            contactDetails.map(async (detail) => {
              try {
                const [Country, State, City] = await Promise.all([
                  getCountryList(),
                  // console.log("EDITTTTT",Country),
                  getStateList(detail.countriesCode),
                  getCityList(detail.stateCode),
                ]);
                // const selectedCountry = {}
                // const selectedState = {}
                // const selectedCity = {}
                const selectedCountry = Country.response.find(
                  (country: CountryLists) => country.countriesCode === detail.countriesCode
                );
                // console.log("detail----->",detail)
                const selectedState = State.response.find(
                  (state: StateList) => state.stateCode === detail.stateCode
                );
                const selectedCity = City.response.find(
                  (city: CityList) => city.cityCode === detail.cityCode
                );
        
                append({
                  contactAddressId: detail.contactAddressId,  
                  contactCompanyName: detail.contactCompanyName || null,  
                  countryDialCodePrefix: detail.countryDialCodePrefix || null, 
                  addressType: detail.addressType || null, 
                  contactFirstName: detail.contactFirstName || "", 
                  contactLastName: detail.contactLastName || null,  
                  addressLine1: detail.addressLine1 || null,  
                  addressLine2: detail.addressLine2 || null, 
                  countriesCode: {
                    value: detail.countriesCode,
                    label: selectedCountry ? selectedCountry.countriesName : "",
                  },
                  state: {
                    value: detail.stateCode,
                    label: selectedState ? selectedState.stateName : "",
                  },
                  city: {
                    value: detail.cityCode,
                    label: selectedCity ? selectedCity.cityName : null,
                  },
                  zoneCode: detail.zoneCode || null,
                  place: detail.place || null,  
                  lat: detail.lat, 
                  lng: detail.lng,  
                  pinCode: detail.pinCode || null,  
                  pincode: detail.pinCode || null,  
                  phoneNo: detail.phoneNo || null,  
                  email: detail.email || null,  
                  isDefault: detail.isDefault, 
                  GSTIN: detail.GSTIN || null,  
                  gstType: {value: detail.gstType || "UnRegistered" , label: detail.gstType || "UnRegistered" }, 
                  panNo: detail.panNo || null, 
                });
                
              } catch (error) {
                console.error("Error processing contact detail:", error);
              }
            })
          );
        }
        
      }
    };
  
    fetchContactDetails();  
  }, [editedData?.ContactDetails?.contactAddress, append]);
  
  

  const handleBlurFirstName = () => {
      const firstNameValue = watch("firstName") 
    const index = 0;
    setValue(`addressDetails.${index}.contactFirstName`, firstNameValue ?? "" , {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };
  

  const handleBlurLastName = () => {
    // const lastNameValue = watch("lastName");
    const lastNameValue = watch("lastName") ?? ""
    const index = 0;
    setValue(`addressDetails.${index}.contactLastName`, lastNameValue,{
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleBlurCreditAmount = () => {
    setValue("debitAmount", null ,{
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleBlurDebitAmount = () => {
    setValue("creditAmount", null,{
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };
useEffect(() => {
    if (fields && fields.length > 0) {
      fields.forEach((field, index) => {
        setValue?.(`addressDetails[${index}].mobNo` as any, field?.phoneNo ,{
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
      }); 
  
  }
}, [fields]); 
   const handleBlurCompanyName = async () => {
    const companyNameValue = watch("companyName");
    const words = companyNameValue && companyNameValue.split(" ");
    const initials = words && words.map((word) => word.charAt(0).toUpperCase()).join("");
    if (initials && !(contactType === "transport")) {
      const supplierCode = await axiosFunction(
        `${v2ReactURL}/contact/${contactType}/code?code=${initials}&contactId=${params.contactId}`,
        `POST`,
      )
      setValue("code", supplierCode.data, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    } else {
      setValue("code", "", {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
    const index = 0;
    setValue(`addressDetails.${index}.contactCompanyName`, companyNameValue,{
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    // setValue(`addressDetails[0].contactCompanyName`, companyNameValue);
  };

  useEffect(() => {
    if(customerTaxType === 'vat' ) {
      setSelectedGSTType({
        value: "UnRegistered",
        label: "UnRegistered",
      });
    } else {
      setValue("vatNo", "");
    }

  },[customerTaxType])

const resetFormFields = () => {
  setValue("customerType", "wholesaler");
  setValue("accountGroupId", {
    label: `${accountGroup?.accountGroupName || ""} (${
      accountGroup?.parentGroup || ""
    })`,
    value:
      editedData?.AccountGroupData?.find((acc) => acc.isDefault === 1)
        ?.accountGroupId ?? null, // Ensure null if undefined
  });
  reset();
};


  const handleClear = () => {
    resetFormFields();
  };

  const capitalizeFirstChar = (string : string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const handleBlurContactNo = () => {
    const numberValue = watch("mobNo");
    setValue(`whatsappNo`, numberValue ,{
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };
 
  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }
  return (
    !isLoading && (
      <Wrapper
        customStyle={{ height: "auto" }}
        subClassName={"addContactWrapper"}
        navUrl = {`${"Edit " + capitalizeFirstChar(contactType)} | ${customerName}`}
      >
        <WrapperSubHeader>
          <Column md={8}></Column>
          <Column md={2}></Column>
          <Column md={2} className="pl-md-0 mt-1 mt-md-0"></Column>
        </WrapperSubHeader>
        <EditContactContainer>
          <WrapperContent>
            <BreadCrumbComponent
              type={`${capitalizeFirstChar(editedData && editedData?.type || "")}  `}
              subType={`${customerName}`}
              subTypeClickable={true}
            />
            <Row>
              <WrapperCard>
                <ContactFormAccordian
                  generalDetailsForm={
                    <GeneralDetailsFormComponent
                      register={register}
                      customerTaxType={customerTaxType}
                      errors={errors}
                      control={control}
                      setValue={setValue}
                      newContactCreatedDetail={editedData}
                      handleBlurFirstName={handleBlurFirstName}
                      handleBlurLastName={handleBlurLastName}
                      handleBlurCompanyName={handleBlurCompanyName}
                      handleBlurContactNo={handleBlurContactNo}
                      handleBlurCreditAmount={handleBlurCreditAmount}
                      handleBlurDebitAmount={handleBlurDebitAmount}
                    />
                  }
                  addressDetailsForm={
                    <AddressDetailsFormNew
                      setSelectedGSTType={setSelectedGSTType}
                      selectedGSTType={selectedGSTType}
                      customerTaxType={customerTaxType}
                      // reset={reset}
                      control={control}
                      errors={errors}
                      // setAddressValue={setValue}
                      register={register}
                      newContactCreatedDetail={editedData}
                      fields={fields}
                      append={append}
                      remove={remove}
                      setDeletedAddress={setDeletedAddress}
                      setValue={setValue}
                      getValues={getValues}
                      setShowVerifyBtn={setShowVerifyBtn}
                      showVerifyBtn={showVerifyBtn}
                      setGstValidMsg={setGstValidMsg}
                      gstValidMsg={gstValidMsg}
                    />
                  }
                />
              </WrapperCard>
            </Row>
          </WrapperContent>
        </EditContactContainer>
        <div
          style={{
            position: "fixed",
            bottom: 0,
            width: `calc(100% - ${isToggle ? 78 : 230}px)`,
            zIndex: 999999999999,
            left: isMobile ? 0 : isToggle ? 78 : 230

          }}
        >
          <Footer
            onSubmit={handleSubmit(onSave)}
            handleClear={handleClear}
            onCreateInvoiceSave={handleSubmit(onCreateInvoiceSave)}
            onCreateNewSave={handleSubmit(onCreateNewSave)}
            onPreviewSave={handleSubmit(onPreviewSave)}
            clearBtn={false}
            addressDetailsError={false}
            isLoading={isLoadingBtn}
            onCancelClick={() => {
              dispatch(resetPhoneNo());
              navigate("/reactcontact");
            }}
          />
        </div>
      </Wrapper>
    )
  );
};

export default EditContact;